export const getIsLoading = (state) => state.loading.isLoading
